import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useGetConfigQuery, useGetDueQuery, useReviewCardMutation } from '../../Redux/Apis/leitnerApi'
import Icon from '../../Components/Icon'
import Dictionary from '../../Components/Dictionary'

export default function LeitnerStudy() {
  const navigate = useNavigate()
  const { data: config } = useGetConfigQuery()
  const limit = config?.reviewNumber ?? 30
  const { data, isFetching, refetch } = useGetDueQuery({ limit })
  const [reviewCard] = useReviewCardMutation()
  const [showDic, setShowDic] = useState(false)
  const [dicWord, setDicWord] = useState('')
  const [statuses, setStatuses] = useState<Record<string, 'correct' | 'wrong' | undefined>>({})

  const items = useMemo(() => {
    const raw = data?.items ?? []
    return raw
      .slice()
      .sort((a: any, b: any) => new Date(b.nextReviewAt || 0).getTime() - new Date(a.nextReviewAt || 0).getTime())
  }, [data])

  const onAnswer = async (id: string, correct: boolean) => {
    setStatuses((s) => ({ ...s, [id]: correct ? 'correct' : 'wrong' }))
    try { await reviewCard({ cardId: id, correct }).unwrap() } catch { /* ignore UI */ }
    // Small delay to show color, then refetch to move forward
    setTimeout(() => { refetch() }, 350)
  }

  return (
    <main className="col-lg-9">
      <div className="panel-surface p-3 mb-3 d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-2">
          <button className="btn btn-light btn-sm d-flex align-items-center gap-1" onClick={() => navigate('/panel/leitner')}>
            <Icon name="chevron-right" size={14} />
            بازگشت
          </button>
          <h6 className="fw-bold m-0">مرور امروز (سراسری)</h6>
        </div>
        <div className="small">{isFetching ? '...' : `نمایش ${Math.min(items.length, limit)} از ${data?.dueCount ?? 0}`}</div>
      </div>

      <div className="panel-surface p-3">
        {items.length === 0 ? (
          <div className="text-center py-5 panel-muted">موردی برای مرور وجود ندارد.</div>
        ) : (
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3">
            {items.map((c: any, idx: number) => {
              const st = statuses[c.id]
              const bg = st === 'correct' ? '#C6F6D5' : st === 'wrong' ? '#FECACA' : '#FFFFFF'
              const border = st === 'correct' ? '#10b981' : st === 'wrong' ? '#ef4444' : 'var(--panel-line)'
              return (
                <div className="col" key={c.id}>
                  <div className="h-100 p-4 rounded-4" style={{ background: bg, border: `1px solid ${border}` }}>
                    <div className="text-center">
                      <div className="fs-4 fw-bold mb-3">{c.front}</div>
                      <button className="btn btn-info text-white fw-bold mb-2" onClick={() => { setDicWord(c.front); setShowDic(true) }}>
                        نمایش معنی
                      </button>
                      <div className="small panel-muted mb-3">{idx + 1} از {items.length}</div>
                      <div className="d-flex justify-content-center gap-2">
                        <button className="btn btn-danger px-4" onClick={() => onAnswer(c.id, false)}>بلد نیستم</button>
                        <button className="btn btn-success px-4" onClick={() => onAnswer(c.id, true)}>بلدم</button>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>

      {showDic && <Dictionary content={dicWord} onClose={() => setShowDic(false)} />}
    </main>
  )
}
